<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
    <p style="color: black">กำลังโหลดข้อมูล...</p>
</ngx-spinner>
<div class="content-wrapper">
    <div class="row">
        <div class="col-2">
            <div class="card">
                <div class="card-header">
                    <h3 class="text-primary"><i class="fas fa-bug"> บันทึกโรค/แมลง</i></h3>
                </div>
                <div class="card-body">
                    <form #frm_addInsert="ngForm" class="needs-validation" >
                        <input type="hidden" #yearid="ngModel" ngModel name="yearid" [(ngModel)]="yearCR">
                        <!-- <input type="hidden" #supcode="ngModel" ngModel name="supcode" [(ngModel)]="supcode"> -->
                        <div class="input-group-prepend">
                            <label>เลือกแปลงอ้อย</label>
                        </div>
                        <input #itid type="text" ngModel name="itid" class="form-control" list="cpdata" id="itid"
                        [ngClass]="{'is-invalid' : itid.invalid && (itid.dirty || itid.touched)}"
                            minlength="18" maxlength="20" required>
                        <datalist id="cpdata">
                            <option *ngFor="let item of cpSupcode" [value]="item.itid" >
                              {{item.intlandno}}
                              {{item.fmname}} {{item.canetype}} {{item.landvalue}} ไร่ รูท {{item.route}}
                            </option>
                        </datalist>
                        <!-- <div class="invalid-feedback">
                            <span *ngIf="cpdata.hasError('required')">ป้อนโควตา 10 หลัก</span>
                          </div> -->
                        <div class="form-group">
                            <label for="" class="form-label">วันที่ตรวจ</label>
                            <input #surveyDay="ngModel" ngModel name="surveyDay" id="surveyDay" type="date" class="form-control" required pattern="\d{4}-\d{2}-\d{2}" 
                            [ngClass]="{'is-invalid' : surveyDay.invalid && (surveyDay.dirty || surveyDay.touched)}" ng-disabled='disabletest'>                            
                        </div>
                        <div class="form-group">
                            <label>โรคที่พบ</label>
                            <select #disease="ngModel" ngModel name="disease" class="form-control" id="disease"
                                [ngClass]="{'is-invalid' : disease.invalid && (disease.dirty || disease.touched)}"
                                required>
                                <option value="" disabled>++เลือกโรคอ้อย++</option>
                                <option value="1">ใบขาว</option>
                                <option value="2">รากเน่า</option>
                                <option value="3">เหี่ยวเน่าแดง</option>
                                <option value="4">แซ่ดำ</option>
                                <option selected value="0">ไม่มีโรคอ้อย</option>
                            </select>
                            <div class="invalid-feedback">
                                <span *ngIf="disease.hasError('required')">กรุณาเลือกโรคอ้อยก่อน</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>% การทำลาย</label>
                            <input #pc_disease="ngModel" ngModel name="pc_disease" id="pc_disease" type="number" class="form-control"
                            [ngClass]="{'is-invalid' : pc_disease.invalid && (pc_disease.dirty || pc_disease.touched)}"
                            minlength="0" maxlength="100" required value="0">
                        </div>
                        <div class="form-group">
                            <label>แมลงที่พบ</label>
                            <select #insect="ngModel" ngModel name="insect" class="form-control"
                            [ngClass]="{'is-invalid' : insect.invalid && (insect.dirty || insect.touched)}"
                            required>
                                <option value="" disabled>++เลือกแมลงอ้อย++</option>
                                <option value="2">หนอนกอลายจุดเล็ก</option>
                                <option value="3">ด้วง</option>
                                <option value="4">ปลวก</option>
                                <option value="5">หนองกอลายจุดใหญ่</option>
                                <option value="6">หนอนกอสีขาว</option>
                                <option value="7">หนอนกอสีชมพู</option>
                                <option value="8">หนอนกอลายแถบ</option>
                                <option value="9">อื่นๆ</option>
                                <option selected value="0">ไม่พบแมลง </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>%การทำลาย</label>
                            <input #pc_insect="ngModel" ngModel name="pc_insect" id="pc_insect" type="number" class="form-control"
                            [ngClass]="{'is-invalid' : pc_insect.invalid && (pc_insect.dirty || pc_insect.touched)}"
                            minlength="0" maxlength="100" required  value="0" >
                        </div>
                        <div class="form-group">
                            <label>%พบแตนเบียน</label>
                            <input #parasitic_wasps="ngModel" ngModel name="parasitic_wasps" id="parasitic_wasps" type="number" class="form-control"
                            [ngClass]="{'is-invalid' : parasitic_wasps.invalid && (parasitic_wasps.dirty || parasitic_wasps.touched)}"
                            minlength="0" maxlength="100" required value="0">
                        </div>
                        <div class="form-group">
                            <label>การแก้ไข</label>
                            <input #Comment_1="ngModel" ngModel name="Comment_1" type="text" class="form-control" placeholder="ป้อนการแก้ไข(ถ้ามี)">
                        </div>
                        <div class="form-group">
                            <button [disabled]="frm_addInsert.invalid" (click)="onSubmit(frm_addInsert.value);"
                                class="btn btn-primary btn-block">บันทึกข้อมูล</button>
                        </div>
                    </form>
                </div>
                <div class="card-footer">

                </div>
            </div>
        </div>
        <div class="col-10">
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title"><i class="fas fa-database"> การบันทึกข้อมูลของท่าน [Supcode
                            {{userdata.supcode}}]</i></h3>
                    <div class="card-tools">
                        <!-- <button type="button" class="btn btn-tool" data-card-widget="card-refresh"
                            data-source="widgets.html" data-source-selector="#card-refresh-content"
                            data-load-on-init="false"><i class="fas fa-sync-alt"></i></button> -->
                        <button (click)="getDatainsect()" type="button" class="btn btn-tool"><i
                                class="fas fa-sync-alt text-primary"></i></button>
                        <button type="button" class="btn btn-tool" data-card-widget="maximize">
                            <i class="fas fa-expand text-primary" ></i></button>
                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fas fa-minus text-primary"></i></button>
                    </div>
                </div>
                <!-- /.card-header -->
                <div class="card-body table-responsive p-2" style="height: 70%">
                    <table class="table table-hover table-head-fixed text-nowrap" #table>
                        <thead>
                            <tr class="headText text-primary">
                                <th>วันที่บันทึก</th>
                                <th>วันที่ตรวจ</th>
                                <th>ข้อมูลแปลง</th>
                                <th>%พบแตนเบียน</th>
                                <th>โรคที่พบ</th>
                                <th>แมลงที่พบ</th>
                                <th>การแก้ไข</th>
                                <th class="text-center"><i class="fas fa-user-md"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dt of plantbyfmlist" (click)="selectData(dt.DataId)"
                                title="(^_^) {{dt.is_Disease_imp}} (^_^) {{dt.is_insect_imp}}" class="tableRow12">
                                <td>{{dt.Daterec | adtob }}</td>
                                <td>{{dt.surveyDay | adtob }}</td>
                                <td>{{dt.intlandno}} {{dt.fmname}} {{dt.CaneTypeName}} {{dt.landvalue}} ไร่
                                    {{dt.seedname}} รูท {{dt.route}} โซน{{dt.supzone}}
                                </td>
                                <td>
                                  <span *ngIf="dt.parasitic_wasps > 0">
                                  <span  class="text-primary"> (% {{dt.parasitic_wasps}})</span>
                                </span>
                                </td>

                                <td>
                                    <span *ngIf="dt.pc_Disease > 0"> {{dt.is_Disease_doc}}
                                        <span class="text-danger">(% {{dt.pc_Disease}})</span>
                                    </span>
                                </td>
                                <td>
                                    <span *ngIf="dt.pc_insect > 0"> {{dt.is_insect_doc}}
                                        <span class="text-danger"> (% {{dt.pc_insect}}) </span>
                                    </span>
                                </td>
                                <td>{{ dt.Comment_1 }}</td>
                                <td class="text-center">
                                    <button (click)="showAdvice(dt.is_insect_imp,dt.is_Disease_imp);" type="button"
                                        class="btn btn-tool btn-sm text-primary">
                                        <i class="fas fa-comments"></i>
                                    </button>
                                </td>                                
                            </tr>

                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-lg-12">
                            <blockquote class="blockquote">
                                <p>dataid:{{ dataSelect.DataId }} แปลง {{ dataSelect.intlandno }} {{ dataSelect.fmname
                                    }} {{ dataSelect.CaneTypeName }}
                                    {{ dataSelect.landvalue }} ไร่</p>
                            </blockquote>
                            <div class="media border p-3 align-middle">
                                <img class="align-self-center mr-3" style="width:50px;"
                                    src="https://storage.googleapis.com/brr-farmluck.appspot.com/supcodePic/{{dataSelect.insect_disease_by}}.png"
                                    alt="supcode">
                                <div class="media-body">
                                    <form #formUpdate="ngForm" (ngSubmit)="saveUpdateInsect(formUpdate.value);">
                                        <input #DataId="ngModel" ngModel name="DataId" type="hidden" id="DataId"
                                            [(ngModel)]="dataSelect.DataId">
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">การแก้ไข</span>
                                            </div>
                                            <input #Comment_1="ngModel" ngModel name="Comment_1" type="text"
                                                [(ngModel)]="dataSelect.Comment_1" class="form-control" id="Comment_1">
                                            <div class="input-group-prepend">
                                                <button type="submit" class="btn btn-primary"> <i class="fas fa-save">
                                                        บันทึก </i></button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<app-footer></app-footer>
